import { render, staticRenderFns } from "./Delete.vue?vue&type=template&id=03c2b9e2&scoped=true&"
import script from "./Delete.vue?vue&type=script&lang=js&"
export * from "./Delete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c2b9e2",
  null
  
)

export default component.exports